module.exports = new __parcel__URL__("EthLogo.13b90052.svg").toString();